import { gql } from "@apollo/client";

const ALL_USERS = gql`
  query allusers($platformId: Int) {
    allusers(platformId: $platformId) {
      name
      surname
      email
      phone
      nation
      gender
      city
      street
      user_club_text
      role
      dob
      avatar
      id
      ipinId
      duprId
      teId
      ltsU10Id
      atpId
      wtaId
      fideId
      teU12Id
      bonusU14
      bonusU12
      bonusPoints
      itf_points
      fivb
      bonusU16
      otherPoints
      createdAt
      wprUserId
      additionalUserRole
    }
  }
`;

export default ALL_USERS;
